import AbsenceReasons from "./AbsenceReasons.jsx";
export default AbsenceReasons;